import { Validator } from 'vee-validate'

Validator.extend('textOnly', {
    getMessage() {
        return 'Input must contain only alphabets and hyphens'
    },
    validate(v) {
        return /^[a-zA-Z -]+$/.test(v)
    }
})

Validator.extend('nameOnly', {
    getMessage() {
        return 'Allowed special characters are & + / : \' , - .'
    },
    validate(v) {
        return /^[\&\+\/\:\'\,\.\- a-zA-Z0-9]+$/.test(v)
    }
})

Validator.extend('common', {
    getMessage() {
        return 'Allowed special characters are & + / : ; \' , - .'
    },
    validate(v) {
        return /^[\&\+\/\:\'\,\.\-\; a-zA-Z0-9]+$/.test(v)
    }
})

Validator.extend('allDigits', {
    getMessage() {
        return 'Input must contain only numbers'
    },
    validate(v) {
        return /^\d+$/.test(v)
    }
})

Validator.extend('phoneNo', {
    getMessage() {
        return 'Phone number can contain space and digits only.'
    },
    validate(v) {
        return /^\d+[\s\d]+$/.test(v)
    }
})

Validator.extend('validNumber', {
    getMessage() {
        return 'Please enter valid number.'
    },
    validate(v) {
        return /^[1-9]\d*$/.test(v)
    }
})

Validator.extend('dateAfter', {
    getMessage(f, args) {
        return (args && args[1]) ?args[1] :'Invalid date.'
    },
    validate(v, args) {
        if(!/^\d+$/.test(v) || !args || !/^\d+$/.test(args[0]))
            return true
        
        return v > args[0]
    }
})

Validator.extend('dateBefore', {
    getMessage(f, args) {
        return (args && args[1]) ?args[1] :'Invalid date.'
    },
    validate(v, args) {
        if(!/^\d+$/.test(v) || !args || !/^\d+$/.test(args[0]))
            return true
        
        return v < args[0]
    }
})
